/* global axios */
/* SolNow — cliente API de las columnas del tablero de tickets */
import ApiClient from './ApiClient';

class TicketColumnsAPI extends ApiClient {
  constructor() {
    super('ticket_columns', { accountScoped: true });
  }

  reorder(ids) {
    return axios.post(`${this.url}/reorder`, { ids });
  }
}

export default new TicketColumnsAPI();
